import { useLocation } from "react-router-dom";
import { routesMetadata } from "../routesMetadata";

export const useRouteItems = (permissions: string[] | undefined) => {
  const routes = routesMetadata;

  const publicRoutes = routes.filter((x) => x.isPublic);
  const privateRoutes = routes.filter((x) => !x.isPublic);

  // const currentRoute = routes.find((x) => x.path === location.pathname);

  // if (
  //   !currentRoute?.authenticationEndpoint ||
  //   permissions?.some(
  //     (x) =>
  //       x.toLowerCase() === currentRoute?.authenticationEndpoint?.toLowerCase()
  //   )
  // ) {
  //   return routes;
  // }
  // // To add logic here for user roles, etc.
  // return routes.filter((x) => x.path !== currentRoute.path);

  return { publicRoutes, privateRoutes };
};
